import { FlexAligner } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { Z_INDEX } from '@/constants';

type StickyRowWrapperProps = {
  $isHidden?: boolean;
  $float?: boolean;
};

export const StickyRowWrapper = styled(FlexAligner)<StickyRowWrapperProps>`
  position: ${({ $float }) => ($float ? 'absolute' : 'relative')};
  z-index: ${Z_INDEX.content.floating};
  opacity: ${({ $isHidden }) => ($isHidden ? 0 : 1)};
  transition: opacity 0.3s ease;
`;

/** Interactive header content (e.g. selects) that must not start a GridStack drag. */
const GRID_NO_DRAG_CLASS = 'grid-no-drag';

export const HeaderComponentSlot = styled.div.attrs({ className: GRID_NO_DRAG_CLASS })`
  display: contents;
`;
